import { Routes } from '@angular/router';
import { hasPermission } from '@tiltgroup/web-components';
import { Permission } from '@shared/interfaces/permission';

export enum QuotesRouting {
  QUOTE_MANAGER = 'manager',
}

export const QUOTES_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./quotes.component').then((m) => m.QuotesComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/quotes-list/quotes-list.component').then(
            (m) => m.QuotesListComponent
          ),
        canMatch: [() => hasPermission(Permission.VIEW_LTL_QUOTE_REQUEST)],
      },
      {
        path: QuotesRouting.QUOTE_MANAGER,
        loadChildren: () =>
          import('./pages/quote-manager/quote-manager-routing').then(
            (m) => m.QUOTE_MANAGER_ROUTES
          ),
        canMatch: [() => hasPermission(Permission.MANAGE_LTL_QUOTE_REQUEST)],
      },
    ],
  },
];
